export default [
  {
    path: '/b2bhub/Account/PermissaoAcesso',
    name: 'permissao-acesso',
    component: () => import('@/views/app/PTC/PermissaoAcesso/viewPermissaoAcesso.vue'),
    meta: {
      pageTitle: 'Permissão de Acesso',
      action: 'read',
      resource: 'Acesso_Permissao',
    },

  },
  {
    path: '/b2bhub/Account/CadastrarUsuario',
    name: 'cadastrar-usuario',
    component: () => import('@/views/app/PTC/PermissaoAcesso/createPermissaoAcesso.vue'),
    meta: {
      pageTitle: 'Permissão de Acesso',
      action: 'read',
      resource: 'Acesso_Permissao',
    },

  },
  {
    path: '/b2bhub/Account/AtualizarUsuario',
    name: 'atualizar-usuario',
    component: () => import('@/views/app/PTC/PermissaoAcesso/updatePermissaoAcesso.vue'),
    meta: {
      pageTitle: 'Permissão de Acesso',
      action: 'read',
      resource: 'Acesso_Permissao',
    },

  },
];
